/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("div", { className: "k-nodata" }, /* @__PURE__ */ e.createElement("div", null, t.children));
export {
  a as ListNoData
};
